import React, { Component, Fragment } from 'react';
import CustomTabs from './CustomTabs';
import {Route, Switch, Redirect} from "react-router-dom";
import BreadCrumb from './BreadCrumb';

import ServiciosCilindroPrecios from './ServiciosCilindroPrecios.js';
import ServiciosCilindroDescuentos from './ServiciosCilindroDescuentos.js';

import ServiciosCilindroPedidos from './ServiciosCilindroPedidos.js';
import ServiciosCilindroPedido from './ServiciosCilindroPedido.js';
import ServiciosCilindroRealizarPedido from './ServiciosCilindroRealizarPedido.js';
import ServiciosGeneralRequerimientos from './ServiciosGeneralRequerimientos.js';
import ServiciosCilindroIndustrialCotizarPedido from './ServiciosCilindroIndustrialCotizarPedido.js';
import ServiciosCilindroIndustrialCotizaciones from './ServiciosCilindroIndustrialCotizaciones.js';
import EmpresasEnvasadoIndustrialCuentaCorriente from './EmpresasEnvasadoIndustrialCuentaCorriente.js';
import EmpresasEnvasadoIndustrialDetalleCuentaCorriente from './EmpresasEnvasadoIndustrialDetalleCuentaCorriente'

import {cilindroBussinesLineList} from '../api.js';
import privilegios from '../privilegios_empresa.js';

export default class EmpresasServiciosCilindro extends Component {
	constructor(props) {
		super(props);
		this.state = {
			solicitud_requerimiento_preload: null
		};
		this.tabs = [
			/*{
				title: "Realizar Pedidos",
				to: "/mis-servicios/cilindro/realizar-pedidos"
			},
			{
				title: "Precios",
				to: "/mis-servicios/cilindro/precios"
			},
			{
				title: "Mis Descuentos",
				to: "/mis-servicios/cilindro/descuentos"
			},
			{
				title: "Pedidos",
				to: [
					"/mis-servicios/cilindro/pedidos",
					"/mis-servicios/cilindro/pedidos/*"
				]
			},
			{
				title: "Requerimientos",
				to: "/mis-servicios/cilindro/requerimientos"
			}*/			
			{
				title: "Cotizar Pedido",
				to: "/mis-servicios/cilindro/cotizar-pedido"
			},
			{
				title: "Cotizaciones",
				to: "/mis-servicios/cilindro/cotizaciones"
			},
			{
				title: "Cuenta Corriente",
				to: [
					"/mis-servicios/cilindro/cuenta-corriente",
					"/mis-servicios/cilindro/cuenta-corriente/*"
				]
			}
		];

	}
	componentDidMount() {
		this.props.changeHeaderClass("medium");
		//this.loadServices();		
	}
	
	setSolicitudRequerimientoPreloadData(data, cb) {
		this.setState({solicitud_requerimiento_preload: data}, cb);
	}
	render() {
		var breadCrumbOptions = [
			{title: "Mis Servicios", to: "/mis-servicios"},
			{title: "Medidor"},
		];
		var priv = this.props.selectedCilindro?this.props.selectedCilindro.pivot.privileges:[];	
		return (
			<Fragment>
				<div className="section-title">
					<h1>Envasado Institucional</h1>
					<BreadCrumb options={breadCrumbOptions} />					
				</div>
				<CustomTabs tabs={this.tabs.filter((tab) => {
					//if(!available.medidor_requerimientos && tab.title === "Requerimientos") return false;


					return true;
				})} location={this.props.location} />		
        		<Switch>
					{/*<Route path="/mis-servicios/cilindro/realizar-pedidos">
	                	<ServiciosCilindroRealizarPedido user={this.props.user} />
		            </Route>
					<Route exact path="/mis-servicios/cilindro/precios">
	                	<ServiciosCilindroPrecios
	                		services={this.state.services} 
	                		selectedService={this.props.selectedCilindro}
	                		setSelectedService={this.props.setSelectedCilindro} />
		            </Route>
		            <Route exact path="/mis-servicios/cilindro/descuentos">
	                	<ServiciosCilindroDescuentos
	                		services={this.state.services} 
	                		selectedService={this.props.selectedCilindro}
	                		setSelectedService={this.props.setSelectedCilindro} />
		            </Route>
		            <Route exact path="/mis-servicios/cilindro/pedidos">
	                	<ServiciosCilindroPedidos
	                		services={this.state.services} 
	                		selectedService={this.props.selectedCilindro}
	                		setSelectedService={this.props.setSelectedCilindro} />
		            </Route>
					<Route path="/mis-servicios/cilindro/pedidos/:id" render={(data)=> 
						<ServiciosCilindroPedido pedido_id={data.match.params.id} />}>
					</Route>
					<Route exact path="/mis-servicios/cilindro/requerimientos">
	                	<ServiciosGeneralRequerimientos
	                		solicitud_requerimiento_preload={this.state.solicitud_requerimiento_preload}
	                		setSolicitudRequerimientoPreloadData={this.setSolicitudRequerimientoPreloadData.bind(this)}
	                		business_line={"cilindro"}
                  			checkMenuOptions={this.props.checkMenuOptions} />	                		
		            </Route>*/}
		            <Route exact path="/mis-servicios/cilindro/cotizar-pedido">
	                	<ServiciosCilindroIndustrialCotizarPedido
	                		services={!this.props.services?null:this.props.services.filter(s=>s.pivot.privileges.indexOf(privilegios.envasado_institucional_cotizar_pedido)>=0)} 
	                		selectedService={this.props.selectedCilindro}
	                		setSelectedService={this.props.setSelectedCilindro}
		                	reloadServices={this.props.reloadServices}	                    	                		
	                		isEmpresas={true} />

		            </Route>
		            <Route exact path="/mis-servicios/cilindro/cotizaciones">
	                	<ServiciosCilindroIndustrialCotizaciones
	                		services={!this.props.services?null:this.props.services.filter(s=>s.pivot.privileges.indexOf(privilegios.envasado_institucional_cotizar_pedido)>=0)} 
	                		selectedService={this.props.selectedCilindro}
	                		setSelectedService={this.props.setSelectedCilindro} />
		            </Route>
					<Route exact path="/mis-servicios/cilindro/cuenta-corriente">
	                	<EmpresasEnvasadoIndustrialCuentaCorriente
	                		services={!this.props.services?null:this.props.services.filter(s=>s.pivot.privileges.indexOf(privilegios.envasado_institucional_cuenta_corriente)>=0)}
	                		selectedService={this.props.selectedCilindro}
							setSelectedService={this.props.setSelectedCilindro}
							reloadServices={this.props.reloadServices} />
		            </Route>
					<Route path="/mis-servicios/cilindro/detalle-documento/:doc_number/:doc_year/:client_code">
						<EmpresasEnvasadoIndustrialDetalleCuentaCorriente
							createActionNotification={this.props.createActionNotification}
							isEmpresa={true}
						/>								
					</Route> 
		            <Route path="*">
		                <Redirect to={"/mis-servicios"} />
		          	</Route>
        		</Switch>
			</Fragment>
		);
	}
}